import type { SidePanel } from '../types';

export const RepaymentDetail: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./RepaymentDetailPanel.vue')),
};
